import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LevelIconComponent } from './level-icon/level-icon.component';
import { LevelLabelComponent } from './level-label/level-label.component';
import { ItemTagComponent } from './item-tag/item-tag.component';
import { ItemActionsComponent } from './item-actions/item-actions.component';
import { ButtonComponent } from './button/button.component';
import { IconComponent } from './icon/icon.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import {FormsModule} from "@angular/forms";
import {DirectivesModule} from "../directives/directives.module";
import { IconCheckboxComponent } from './icon-checkbox/icon-checkbox.component';
import { ExpandableBlockFooterComponent } from './expandable-block-footer/expandable-block-footer.component';
import { AccordionComponent } from './accordion/accordion.component';
import { AccordionSetComponent } from './accordion-set/accordion-set.component';
import { NotificationComponent } from './notification/notification.component';
import { NotificationsContainerComponent } from './notification/notifications-container/notifications-container.component';
import { ImageComponent } from './image/image.component';
import { SvgHighlightComponent } from './svg-highlight/svg-highlight.component';
import { LoaderComponent } from './loader/loader.component';
import { GameOrganizationLogoComponent } from './game-organization-logo/game-organization-logo.component';
import { PulseCircleComponent } from './pulse-circle/pulse-circle.component';
import { InputTextComponent } from './input-text/input-text.component';
import { CustomDropzoneComponent } from './custom-dropzone/custom-dropzone.component';
import { TrophyIconComponent } from './trophy-icon/trophy-icon.component';
import { LevelActivityLabelComponent } from './level-activity-label/level-activity-label.component';
import { HexagonIconComponent } from './hexagon-icon/hexagon-icon.component';
import {TranslateModule} from "@ngx-translate/core";
import { RichTextEditorComponent } from './rich-text-editor/rich-text-editor.component';

@NgModule({
    declarations: [
        LevelIconComponent,
        RichTextEditorComponent,
        LevelLabelComponent,
        ItemTagComponent,
        ItemActionsComponent,
        ButtonComponent,
        IconComponent,
        CheckboxComponent,
        IconCheckboxComponent,
        ExpandableBlockFooterComponent,
        AccordionComponent,
        AccordionSetComponent,
        NotificationComponent,
        NotificationsContainerComponent,
        ImageComponent,
        SvgHighlightComponent,
        LoaderComponent,
        GameOrganizationLogoComponent,
        PulseCircleComponent,
        InputTextComponent,
        CustomDropzoneComponent,
        TrophyIconComponent,
        LevelActivityLabelComponent,
        HexagonIconComponent,
    ],
  exports: [
    LevelIconComponent,
    RichTextEditorComponent,
    LevelLabelComponent,
    ItemTagComponent,
    ItemActionsComponent,
    ButtonComponent,
    IconComponent,
    CheckboxComponent,
    IconCheckboxComponent,
    ExpandableBlockFooterComponent,
    AccordionComponent,
    NotificationsContainerComponent,
    ImageComponent,
    SvgHighlightComponent,
    AccordionSetComponent,
    LoaderComponent,
    GameOrganizationLogoComponent,
    PulseCircleComponent,
    InputTextComponent,
    CustomDropzoneComponent,
    TrophyIconComponent,
    LevelActivityLabelComponent,
    HexagonIconComponent,
  ],
    imports: [
        CommonModule,
        FormsModule,
        DirectivesModule,
        TranslateModule
    ]
})
export class AtomsModule { }
